import React from 'react';
import Head from '@docusaurus/Head';
import { useLocation } from '@docusaurus/router';

// Advertise the markdown twin of each documentation page to AI agents and other
// clients. docusaurus-plugin-llms-txt writes a raw-markdown copy of every page
// at "<url>.md"; this emits a <link rel="alternate" type="text/markdown"> in the
// page head so an agent that fetches the HTML can discover and follow the .md.
//
// Only routes that actually have a markdown twin get the link. Auto-generated
// category (table-of-contents) pages are built by Docusaurus, not from a source
// markdown file, so they have no .md and are excluded.
const MD_ROUTE_PREFIXES = ['/docs/', '/concepts/', '/regulations/', '/schema/', '/dda/'];

function markdownHref(pathname) {
  if (pathname.includes('/category/')) return null;
  if (!MD_ROUTE_PREFIXES.some((prefix) => pathname.startsWith(prefix))) return null;
  const clean = pathname.replace(/\/+$/, '');
  return clean ? `${clean}.md` : null;
}

export default function Root({ children }) {
  const { pathname } = useLocation();
  const href = markdownHref(pathname);
  return (
    <>
      {href && (
        <Head>
          <link rel="alternate" type="text/markdown" href={href} />
        </Head>
      )}
      {children}
    </>
  );
}
